import { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';
import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const fetchCampaignCreatorCountsRequestSchema = z.object({
  platform: z.enum(SOURCE_PLATFORM_TYPE).optional(),
  label: z.string().trim().min(1).optional(),
  name: z.string().trim().min(1).optional(),
});

export type FetchCampaignCreatorCountsRequest = z.infer<
  typeof fetchCampaignCreatorCountsRequestSchema
>;

export async function FetchCampaignCreatorCount(
  campaignId: string,
  pending: boolean,
  request?: FetchCampaignCreatorCountsRequest,
  signal?: AbortSignal,
): Promise<number> {
  const parsedRequest = fetchCampaignCreatorCountsRequestSchema.parse(request ?? {});
  const endpoint = pending
    ? `campaigns/${campaignId}/pending_creators/count`
    : `campaigns/${campaignId}/creators/count`;
  const response = await socialApiClient.get<{ count: number }>(endpoint, {
    searchParams: parsedRequest,
    signal,
  });

  return (await response.json()).count;
}
